module.exports = __webpack_public_path__ + "static/reports@2x-1ca6de0c53bb50177ab56f2a61032d82.png";